import * as React from "react";
import type { SVGProps } from "react";
const SvgSun = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#sun_svg__a)">
      <path
        fill="currentColor"
        d="M13 1a1 1 0 1 0-2 0zm-2 2a1 1 0 1 0 2 0zm2 18a1 1 0 1 0-2 0zm-2 2a1 1 0 1 0 2 0zM4.927 3.513a1 1 0 0 0-1.414 1.414zm.006 2.834a1 1 0 0 0 1.414-1.414zm14.134 11.306a1 1 0 0 0-1.414 1.414zm.006 2.834a1 1 0 0 0 1.414-1.414zM1 11a1 1 0 1 0 0 2zm2 2a1 1 0 1 0 0-2zm18-2a1 1 0 1 0 0 2zm2 2a1 1 0 1 0 0-2zM3.513 19.073a1 1 0 1 0 1.414 1.414zm2.834-.006a1 1 0 1 0-1.414-1.414zM17.653 4.933a1 1 0 0 0 1.414 1.414zm2.834-.006a1 1 0 0 0-1.414-1.414zM16 12a4 4 0 0 1-4 4v2a6 6 0 0 0 6-6zm-4 4a4 4 0 0 1-4-4H6a6 6 0 0 0 6 6zm-4-4a4 4 0 0 1 4-4V6a6 6 0 0 0-6 6zm4-4a4 4 0 0 1 4 4h2a6 6 0 0 0-6-6zm-1-7v2h2V1zm0 20v2h2v-2zM3.513 4.927l1.42 1.42 1.414-1.414-1.42-1.42zm14.14 14.14 1.42 1.42 1.414-1.414-1.42-1.42zM1 13h2v-2H1zm20 0h2v-2h-2zM4.927 20.487l1.42-1.42-1.414-1.414-1.42 1.42zm14.14-14.14 1.42-1.42-1.414-1.414-1.42 1.42z"
      />
    </g>
    <defs>
      <clipPath id="sun_svg__a">
        <path
          fill="#fff"
          d="M0 0h24v24H0z"
        />
      </clipPath>
    </defs>
  </svg>
);
export default SvgSun;
